module.exports = __webpack_public_path__ + "static/media/ernest.565c2bb9.jpg";